import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { cascoQuotationLite } from "./fragments";
import { rcaQuotationLite } from "./fragments";

export const CACHE_CREDENTIALS_RESET = gql`
  subscription cacheCredentialsReset {
    cacheCredentialsReset {
      success
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CACHE_CONFIGURATIONS_RESET = gql`
  subscription cacheConfigurationsReset {
    cacheConfigurationsReset {
      success
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const SERVICE_CONNECTION_CHECKED = gql`
  subscription serviceConnectionChecked {
    serviceConnectionChecked {
      success
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const DB_CONNECTION_CHECKED = gql`
  subscription dbConnectionChecked {
    dbConnectionChecked {
      success
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const INSURERS_CONNECTION_CHECKED = gql`
  subscription insurersConnectionChecked {
    insurersConnectionChecked {
      success
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const SERVICE_STATUS_CHECKED = gql`
  subscription serviceStatusChecked {
    serviceStatusChecked {
      success
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const ERP_VERSION_DATA = gql`
  subscription erpVersionData {
    erpVersionData {
      clientId
      version
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const DEIMOS_VERSION = gql`
  subscription deimosVersionRetrieved {
    deimosVersionRetrieved {
      version
      date
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CASCO_QUOTATIONS_RETRIEVED = gql`
  subscription cascoQuotationsRetrieved {
    cascoQuotationsRetrieved {
      cascoQuotationsLite {
        ...cascoQuotationLite
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${cascoQuotationLite}
  ${messageHeaders}
`;

export const CASCO_CHECK_FLOW_FAILED = gql`
  subscription cascoCheckFlowFailed {
    cascoCheckFlowFailed {
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const CASCO_CROSS_CHECK_FINISHED = gql`
  subscription cascoCrossCheckFinished($documentId: Int!) {
    cascoCrossCheckFinished(documentId: $documentId) {
      documentId
      documentNumber
      documentDate
      existingQuotations {
        ...cascoQuotationLite
      }
      newQuotations {
        ...cascoQuotationLite
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${cascoQuotationLite}
  ${messageHeaders}
`;

export const CASCO_CROSS_CHECK_FAILED = gql`
  subscription cascoCrossCheckFailed($documentId: Int!) {
    cascoCrossCheckFailed(documentId: $documentId) {
      documentId
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const RCA_CROSS_CHECK_FINISHED = gql`
  subscription rcaCrossCheckFinished($documentId: Int!) {
    rcaCrossCheckFinished(documentId: $documentId) {
      documentId
      documentNumber
      documentDate
      existingQuotations {
        ...rcaQuotationLite
      }
      newQuotations {
        ...rcaQuotationLite
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${rcaQuotationLite}
  ${messageHeaders}
`;

export const RCA_CROSS_CHECK_FAILED = gql`
  subscription rcaCrossCheckFailed($documentId: Int!) {
    rcaCrossCheckFailed(documentId: $documentId) {
      documentId
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
